import AdditionalFieldOption from "../models/module/additionalfield/AdditionalFieldOption";
import API from "../services/api";

export default class AdditionalFieldOptionRepository {
    static all = (moduleId, fieldId) => API.get('/module/additional-field/option/all?id=' + fieldId, { module_id: moduleId }).then(response => response.data.options.map(item => AdditionalFieldOption.fromJson(item.option)));
    static get = (id) => API.get('/module/additional-field/option/details/' + id).then(response => response.data);

    static create = (data) => API.post('/module/additional-field/option/create', data);
    static update = (data) => API.post('/module/additional-field/option/update', data).then(response => response.data);
    static updateTree = (data) => API.post('/module/additional-field/option/update/order', { tree: data });
    static delete = (id) => API.delete('/module/additional-field/option/delete?id=' + id);
}